<template>
  <div class="bg-white p-4">
    <div class="w-100 mb-4 d-flex justify-content-between align-items-center">
      <div class="btn-group mr-4">
        <router-link
          tag="button"
          to=""
          class="btn2 btn2-primary btn2-md mr-1 mb-3 mb-sm-0"
          @click.native="showCreate"
          v-if="role_modules.some(item => item.value == 'user.create')"
        >
          <i class="uil-plus mr-1"></i> Create User
        </router-link>
        <button class="btn2 btn2-primary btn2-md mr-1 mb-3 mb-sm-0" 
          @click="showInvitation" 
          v-if="role_modules.some(item => item.value == 'user.invite_user')">
          <i class="uil-envelope-share mr-1"></i> {{ $t('user.action.invite_user') }}
        </button>
      </div>
      <div class="d-flex align-items-center">
        <div style="width: 180px;">
          <multiselect
            ref="Tag"
            autocomplete
            :multiple="true"
            v-model="filteredType"
            :options="roleOptions"
            :searchable="true"
            placeholder="Access Type"
            :clear-on-select="false"
            :close-on-select="false"
            :show-labels="false"
            track-by="name"
            label="name"
            @input="onInputFilter()"
          >
            <template #selection="{ values, search, isOpen }">
              <span class="multiselect__single"
                    v-if="values.length"
                    v-show="!isOpen">{{ values.length }} type(s) selected
              </span>
            </template>
          </multiselect>
        </div>
        <div class="btn-group ml-1 float-right" ref="filterButton">
          <button type="button" class="btn btn-white-primary" @click="toggleFilter" value="all">All</button>
          <button type="button" class="btn btn-white-primary" @click="toggleFilter" value="activated">
            Active
          </button>
          <button type="button" class="btn btn-white-primary" @click="toggleFilter" value="deactivated">
            Deactivated
          </button>
        </div>
      </div>
    </div>
    <Table 
      ref="table" 
      :initialLoad="false"
    /> 
    <!-- <InviteModal ref="inviteModal" @onInvited="onInvited" type="users" /> -->
    <!-- <CreateModal ref="createModal" @onCreated="onCreated" :userData="user" type="users" /> -->
    <Dialog
      customBtnClass="component-custom"
      :parameters="{
        userData: user,
        type: 'users'
      }"
      :titleHtml="'<i class=\'uil-user-plus mr-1\'></i> Create User'"
      :component="computedComponent"
      :buttonDisable="created"
      centered
      size="lg"
      ref="createModal"
      yesText="Create"
      noText="Cancel"
      @onYes="createUser"
    />

    <Dialog
      id="userTypeInvite"
      is_reset_model
      :titleHtml="'<i class=\'uil-envelope-share mr-1\'></i> Invite a user'"
      :component="computedInviteComponent"
      :parameters="{ type: 'users' }"
      :buttonDisable="invited"
      centered
      size="md"
      ref="inviteModal"
      yesText="Invite"
      noText="Cancel"
      @onYes="onInviteUser"
    />
  </div>
</template>

<script>
// import InviteModal from '@components/modals/inviteUserModal'
import Table from './table/user'
import Dialog from '@components/offcanvas'
import UserCreate from '@src/views/pages/administration/user/components/dialogs/create.vue'
import AuthMixins from '@mixins/auth'
import InviteComponent from './components/dialogs/invite.vue'

import error from '@utils/error'

const types = {
  "all":0,
  "active":1,
  "deactivated":2
}

export default {
  mixins: [ AuthMixins ],
  components: { 
    // InviteModal, 
    Table, 
    Dialog,
  },
  computed: {
    computedComponent () {
      return UserCreate
    },
    computedInviteComponent() {
      return InviteComponent
    }
  },
  data(){
    return {
      created: false,
      invited: false,
      filteredType: null,
      roleOptions:[],
      type: ''
    }
  },
  methods:{
    onInviteUser(val) {
      this.invited = true;
      let model = val && val.model && Object.entries(val.model).length ? val.model : val

      return this.$store.dispatch('user/invite', model)
      .then(res => {
        if (res && res.data) {
          if(!res.data.success)
            return error.errorHandler({ message: res.data.msg }, this.$bvToast);
          
          this.$refs.inviteModal.hide();
          this.$bvToast.toast('User successfully invited!', {
            variant: 'success',
            title: "Notification"
          });
          setTimeout(() => {
            this.invited = false;
          }, 1500)
        }
      })
      .catch(err => {
        this.invited = false;
        return error.errorHandler(err, this.$bvToast);
      })
    },
    toggleFilter(e) {
      let filterButton = this.$refs['filterButton'],
        children = filterButton.children

      for(var key in children){
        if(typeof children[key] == 'object'){
          children[key].classList.add('btn-white-primary')
          children[key].classList.remove('btn-primary')
        }
      }

      e.target.classList.add('btn-primary')
      e.target.classList.remove('btn-white-primary')
      this.type = e.target.value
      this.$refs['table'].fetchData('users', e.target.value)
    },
    onInputFilter(){
      let access_type = this.filteredType.map(data => data.role); 
      console.log(access_type)
      this.$refs['table'].fetchData('users', this.type, access_type)
    },
    showInvitation(){
      this.$refs.inviteModal.show()
    },
    showCreate(){
      this.$refs.createModal.show()
    },
    onInvited(){
      this.$emit('onInvited')
      this.load()
    },
    onCreated(){
      this.load()
    },
    load(){
      var route = this.$route.query.type
      this.toggleFilter({
        target:this.$refs['filterButton'].children[types[route || 'all']]
      })
      this.$store.dispatch('role/get').then(res =>{
        console.log('check:',res.data);
        this.roleOptions = res.data
      });
    },
    createUser(ref) {
      this.created = true;
      let reference = ref || {}
      let model = { ...reference.model }
      model._type = reference.type
      ref.validateForm && ref.validateForm()
      if (ref.$v && ref.$v.$error) {
        this.created = false;
        return error.errorHandler({ message: "Required field(s) must not be empty" }, this.$bvToast)
      }

      var formData = new FormData();
      if(model.files){
        model.files.forEach((file) => {
          formData.append("files", file);
        });
      }
      if(model.function_id && model.function_id.length) {
        model.function_id.forEach((res) => {
          formData.append("function_id", res);
        });
      }
      if(model.industry_id && model.industry_id.length) {
        model.industry_id.forEach((res) => {
          formData.append("industry_id", res);
        });
      }
      if(model.brand_id && model.brand_id.length) {
        model.brand_id.forEach((res) => {
          formData.append("brand_id", res);
        });
      }

      formData.append("access_type_id", model.access_type._id || model.access_type);
      formData.append("access_type", model.access_type);
      formData.append("first_name", model.first_name);
      formData.append("last_name", model.last_name);
      formData.append("fixed", model.fixed);
      formData.append("rate", model.rate);
      formData.append("contract_start_date", model.contract_start_date);
      formData.append("contract_end_date", model.contract_end_date);
      formData.append("email", model.email);
      formData.append("password", model.password);
      formData.append("confirm_password", model.confirm_password);
      formData.append("_type", model._type);

      this.$store.dispatch('user/create', formData)
      .then(result => {
        if (result && result.data) {
          this.$refs.table.fetchData();
          this.$refs.createModal.hide();
          setTimeout(() => {
            this.created = false;
          }, 1500)
        }
      })
     .catch(err => {
      this.created = false;
      return error.errorHandler(err, this.$bvToast);
     })
    }
  },
  mounted(){
    this.load()
  }
}
</script>